"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Text: {
    kind: 'Text',
    props: {
      color: '--color-light',
      'vertical-align': 'middle',
      children: 'We use cookies to improve your experience on our site. By using our site, you consent to out use of cookies.'
    }
  },
  Button: {
    kind: 'Button',
    props: {
      children: 'Accept',
      color: '--color-primary',
      background: '--color-light'
    }
  }
};
exports["default"] = _default;